// Phase 6.C — viewport hook. window.innerWidth 기반 mobile/tablet/desktop 분기.
// 시안 design/v3/Chrome.jsx 등이 사용하는 viewport prop 과 동일한 분기 (480/900 px).
//
// 매핑:
//   - mobile  : <  640
//   - tablet  : >= 640 && < 1024
//   - desktop : >= 1024
//
// SSR 안전: window 미정의 시 'desktop' default. 실 SPA 라 무관하지만 명시적 처리.

import { useEffect, useState } from 'react';

export type Viewport = 'mobile' | 'tablet' | 'desktop';

const MOBILE_MAX = 640;
const TABLET_MAX = 1024;

function detect(): Viewport {
  if (typeof window === 'undefined') return 'desktop';
  const w = window.innerWidth;
  if (w < MOBILE_MAX) return 'mobile';
  if (w < TABLET_MAX) return 'tablet';
  return 'desktop';
}

export function useViewport(): Viewport {
  const [vp, setVp] = useState<Viewport>(detect);

  useEffect(() => {
    const onResize = () => setVp(detect());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return vp;
}
